import { FormInput } from "components/Extra/FormInput"
import { CurrentStage } from "pages/admin/Offers/Modals/AddNewOffer/AddNewOffer"
import React, { useState } from "react"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap"
import { useTranslation } from "react-i18next"

interface PriceDetailsSectionProps {
  currentStage: CurrentStage
  openThirdAccordion: string
  setOpenThirdAccordion: React.Dispatch<React.SetStateAction<string>>
  validation: any
}

export const PriceDetailsSection: React.FC<PriceDetailsSectionProps> = ({
  currentStage,
  openThirdAccordion,
  setOpenThirdAccordion,
  validation,
}) => {
  const { t } = useTranslation()

  // State for toggle between percentage and absolute price
  const [isPercentageMode, setIsPercentageMode] = useState(true)

  const removeProduct = (id: string) => {
    validation.setFieldValue(
      "products",
      validation.values.products.filter((product: any) => product.id !== id)
    )
  }

  return (
    <Accordion open={openThirdAccordion} className="mt-4">
      <AccordionItem>
        <AccordionHeader
          targetId="0"
          onClick={() =>
            setOpenThirdAccordion(openThirdAccordion === "0" ? "1" : "0")
          }
        >
          {currentStage === "addNewOffer"
            ? t("campaigns_price")
            : t("offers_price")}
        </AccordionHeader>
        <AccordionBody accordionId="0">
          {currentStage === "addNewOffer" ? (
            <FormGroup>
              <div className="d-flex align-items-center mb-2">
                <Label for="price" className="mb-0 me-3">
                  {t("common_price")} ({isPercentageMode ? "%" : t("common_qar")})
                </Label>
                <div
                  className="form-check form-switch"
                  style={{ cursor: "pointer" }}
                  onClick={() => setIsPercentageMode(!isPercentageMode)}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={isPercentageMode}
                    onChange={() => setIsPercentageMode(!isPercentageMode)}
                  />
                </div>
              </div>
              <Input
                type="number"
                id="price"
                name="price"
                placeholder={
                  isPercentageMode ? (t("offers_enterPrice") as string) : "100"
                }
                value={validation.values.price || ""}
                onChange={e =>
                  validation.setFieldValue("price", e.target.value)
                }
                onBlur={validation.handleBlur}
                invalid={
                  validation.touched.price && validation.errors.price
                    ? true
                    : false
                }
                min={isPercentageMode ? 0 : undefined}
                max={isPercentageMode ? 100 : undefined}
                step={isPercentageMode ? 1 : 0.01}
              />
              {validation.touched.price && validation.errors.price ? (
                <FormFeedback type="invalid">
                  {validation.errors.price}
                </FormFeedback>
              ) : (
                <div className="d-flex align-items-center gap-1 mt-1">
                  <i className="bx bx-info-circle"></i>
                  <small className="text-muted">{t("offers_priceInfo")}</small>
                </div>
              )}
            </FormGroup>
          ) : validation.values.products.length ? (
            <div className="d-flex flex-column justify-between align-center w-100 gap-3 pb-3">
              {validation.values.products.map((product: any) => (
                <div
                  key={product.id}
                  className="w-100 d-flex justify-content-start align-items-center gap-3"
                  style={{
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    borderRadius: "8px",
                    border: "1px solid #30303014",
                    backgroundColor: "#FCFCFC",
                    boxShadow: `
                              0px 124px 74px 0px #0000000D,
                              0px 220px 88px 0px #00000003,
                              0px 344px 96px 0px #00000000
                              `,
                  }}
                >
                  <div
                    className="d-flex flex-column justify-content-center align-items-start"
                    style={{
                      position: "relative",
                      paddingTop: "16px",
                      paddingBottom: "16px",
                    }}
                  >
                    <div className="d-flex flex-column gap-1">
                      <img
                        className="rounded-3"
                        style={{ width: "62px", height: "62px" }}
                        src="https://i.pinimg.com/736x/a9/ee/32/a9ee32f627c6105ea0968fe47afe5d89.jpg"
                      />
                      <button
                        className="position-absolute p-0 border-0 translate-middle text-danger fw-bold bg-white rounded-circle text-center"
                        style={{
                          top: "28px",
                          left: "50px",
                          width: "16px",
                          height: "16px",
                        }}
                        onClick={() => removeProduct(product.id)}
                      >
                        <i className="bx bx-x bx-xs fw-bolder text-danger"></i>
                      </button>
                      <span className="d-block text-center fw-bold">
                        {product.name}
                      </span>
                    </div>
                  </div>
                  <div className="flex-grow-1">
                    <FormInput
                      label={t("offers_beforeOffer") as string}
                      name="beforeOffer"
                      type="text"
                      value="100 QAR"
                      readOnly
                    />
                  </div>
                  <div className="flex-grow-1">
                    <FormInput
                      label={t("offers_afterOffer") as string}
                      name="afterOffer"
                      type="text"
                      value="50 QAR"
                      readOnly
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <></>
          )}
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  )
}
